exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-container {\n  line-height: normal;\n  font-weight: 200;\n  cursor: pointer; }\n  .button-container span {\n    line-height: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/toggle-button/toggle-button.component.scss
// module id = ../../../../../src/app/common/toggle-button/toggle-button.component.scss
// module chunks = main